// extracted by mini-css-extract-plugin
export var drawerPaper = "_3n-0";
export var itemCard = "_3n-1";
export var itemImage = "_3n-2";